import {
  MultiValue
} from "./chunk-Q4Z3QUO7.mjs";

// src/multiselect/src/components/react-select-components/value-container.tsx
import { components } from "react-select";
import React, { Children, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function isMultiValue(child) {
  if (React.isValidElement(child) && child.type === MultiValue && Boolean(child.props.data)) {
    const props = child.props;
    return typeof props.data.label === "string" && typeof props.data.value === "string";
  }
  return false;
}
function isPlaceholder(child) {
  if (React.isValidElement(child) && Boolean(child.props)) {
    return child.type === components.Placeholder;
  }
  return false;
}
function isInput(child) {
  if (React.isValidElement(child) && Boolean(child.props)) {
    return child.type === components.Input;
  }
  return false;
}
function Pills({
  pills = [],
  options = []
}) {
  const groupedPills = pills.reduce((grouped, pill) => {
    if (Boolean(pill.data.isChild)) {
      const parentIsSelected = pills.some(
        (x) => x.data.value === pill.data.parentValue
      );
      const otherChildSelcted = grouped.some(
        (x) => x.data.value === pill.data.parentValue
      );
      if (parentIsSelected || otherChildSelcted) {
        return grouped;
      }
      const parentData = options.find((x) => x.value === pill.data.parentValue);
      if (parentData) {
        return grouped.concat({
          ...pill,
          data: parentData
        });
      }
    }
    return grouped.concat(pill);
  }, []);
  return groupedPills.map((pill) => {
    const selectedChildrenCount = pills.filter(
      (x) => x.data.parentValue === pill.data.value
    ).length;
    const totalChildren = options.filter(
      (x) => x.parentValue === pill.data.value
    ).length;
    const label = selectedChildrenCount === totalChildren ? pill.data.label : `${pill.data.label} (${selectedChildrenCount})`;
    return /* @__PURE__ */ jsx(MultiValue, { ...pill, children: label }, pill.data.value);
  });
}
var ValueContainer = (props) => {
  const { pills, input, placeholder } = useMemo(() => {
    if (Boolean(props.children)) {
      const childrenArray = Children.toArray(props.children);
      const inputChildren = childrenArray.filter(isInput);
      const pillsChildren = childrenArray.filter(isMultiValue);
      const placeholderChildren = childrenArray.filter(isPlaceholder);
      return {
        input: inputChildren,
        pills: pillsChildren.map((pill) => pill.props),
        placeholder: placeholderChildren
      };
    }
    return {};
  }, [props.children]);
  return /* @__PURE__ */ jsxs(components.ValueContainer, { ...props, children: [
    placeholder,
    /* @__PURE__ */ jsx(
      Pills,
      {
        options: props.selectProps.options,
        pills
      }
    ),
    input
  ] });
};

export {
  ValueContainer
};
